/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPaymentsRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {GetPaymentsResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const getPayments = (request: GetPaymentsRequest, options?: CashRequestOptions) => post<GetPaymentsRequest, GetPaymentsResponse>("/2.0/cash/get-payments", request, {...options, rejectOnError: true })